import TriggerNotificationsList from './TriggerNotificationsList';

import { endOfDay, startOfDay } from '@cobliteam/utils/date';

import { useGetUnreadNotificationsAmount } from '@cobliteam/hooks/src/useEntity/useAlerts';

import { Button, DropdownMenu, Tooltip } from '@cobliteam/ui/components';

import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';

const today = new Date();
const limitDay = new Date(new Date().setDate(today.getDate() - 10));

const NotificationsButton = () => {
  const startOfDayISO = startOfDay(limitDay).toISOString();
  const endOfDayISO = endOfDay(today).toISOString();
  const { data: unreadAmount, refetch } = useGetUnreadNotificationsAmount(startOfDayISO, endOfDayISO);
  const amountLabel = unreadAmount && unreadAmount < 10 ? unreadAmount.toString() : '9+';

  return (
    <DropdownMenu>
      <DropdownMenu.Trigger>
        <Tooltip content='Notificações' asChild>
          <div className='relative'>
            <Button variant='outlined' color='secondary' size='condensed' icon={<NotificationsRoundedIcon />} />
            {unreadAmount ? <div className='absolute bg-danger text-white -right-2 -top-1 rounded-full text-[10px] px-[5px]'>{amountLabel}</div> : null}
          </div>
        </Tooltip>
      </DropdownMenu.Trigger>

      <DropdownMenu.Content className='w-[500px] p-0'>
        <TriggerNotificationsList hasUnreadNotifications={Boolean(unreadAmount)} onMarkAllAsRead={() => refetch()} />
      </DropdownMenu.Content>
    </DropdownMenu>
  );
};

export default NotificationsButton;
